export default __webpack_public_path__ + "assets/fonts/a34f36f6061262d4fabd3a37368b0d9d.png";